import { useCallback } from 'react';
import { ORDER_TABS } from '@/pages/wxMall/config';
import { jumpToPageByH5 } from '@/utils/fn';
import { reportClick } from '@/utils/report';
import styles from '../index.less';

const PAGE_NAME = 'record_and_order';

const OrderTabs = ({ activeTab }) => {
  const handleOrderTabChange = useCallback(
    currentTab => {
      if (currentTab === activeTab) return;
      reportClick({
        page_name: PAGE_NAME,
        button_name: `${currentTab}_tab`,
      });
      jumpToPageByH5(`/wxMall/order/list/${currentTab}`, { replace: true });
    },
    [activeTab]
  );

  return (
    <ul className={styles.orderTabs}>
      {ORDER_TABS.map(item => (
        <li
          key={item.value}
          onClick={() => handleOrderTabChange(item.value)}
          className={item.value === activeTab ? styles.active : ''}
        >
          {item.label}
        </li>
      ))}
    </ul>
  );
};
export default OrderTabs;
